
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

export default function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/784069abbb5d0e565eafdc580904c62f/5a64eb61aa29777aaae201bcdd9764aa.png" 
                alt="Mandado Express Logo" 
                className="h-12 w-auto"
              />
            </Link>
            
            <Link 
              to="/"
              className="bg-emerald-500 text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-emerald-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Volver al Inicio
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-5xl font-bold text-gray-900 mb-4">Política de Privacidad</h1>
        <p className="text-gray-500 mb-12">Última actualización: Enero 2025</p>

        <div className="prose prose-lg max-w-none">
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">1. Introducción</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              En Mandado Express, respetamos su privacidad y nos comprometemos a proteger sus datos personales. 
              Esta Política de Privacidad explica cómo recopilamos, usamos, compartimos y protegemos su información 
              cuando utiliza nuestros servicios.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Al utilizar nuestros servicios, usted acepta las prácticas descritas en esta política. Si no está de 
              acuerdo, le recomendamos no utilizar nuestros servicios.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">2. Información que Recopilamos</h2>
            
            <h3 className="text-2xl font-semibold text-gray-900 mb-3 mt-6">2.1 Información que Usted Proporciona</h3>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li><strong>Datos de registro:</strong> Nombre, correo electrónico, número de teléfono, dirección</li>
              <li><strong>Información de pago:</strong> Datos de tarjetas o cuentas bancarias (procesados de forma segura)</li>
              <li><strong>Documentos:</strong> Para conductores, licencia de conducción, SOAT, documentos del vehículo</li>
              <li><strong>Comunicaciones:</strong> Mensajes, llamadas y comentarios que nos envía</li>
            </ul>

            <h3 className="text-2xl font-semibold text-gray-900 mb-3 mt-6">2.2 Información Recopilada Automáticamente</h3>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Ubicación:</strong> Datos de GPS para coordinar servicios de transporte y mensajería</li>
              <li><strong>Dispositivo:</strong> Tipo de dispositivo, sistema operativo, identificadores únicos</li>
              <li><strong>Uso:</strong> Páginas visitadas, funciones utilizadas, tiempo de uso</li>
              <li><strong>Cookies:</strong> Información almacenada en su navegador para mejorar la experiencia</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">3. Cómo Usamos su Información</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Utilizamos la información recopilada para:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Prestar servicios:</strong> Conectar usuarios con conductores, procesar pagos, coordinar entregas</li>
              <li><strong>Mejorar la plataforma:</strong> Analizar el uso para optimizar funcionalidades</li>
              <li><strong>Comunicación:</strong> Enviar confirmaciones, actualizaciones y notificaciones importantes</li>
              <li><strong>Seguridad:</strong> Prevenir fraudes, proteger a usuarios y conductores</li>
              <li><strong>Marketing:</strong> Enviar promociones y ofertas (puede darse de baja en cualquier momento)</li>
              <li><strong>Cumplimiento legal:</strong> Responder a solicitudes legales y regulatorias</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">4. Compartir su Información</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Podemos compartir su información con:
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mb-3 mt-6">4.1 Conductores y Usuarios</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Compartimos información necesaria entre usuarios y conductores para coordinar servicios (nombre, ubicación, 
              número de contacto).
            </p>

            <h3 className="text-2xl font-semibold text-gray-900 mb-3 mt-6">4.2 Proveedores de Servicios</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Trabajamos con terceros que nos ayudan a operar la plataforma:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Procesadores de pagos</li>
              <li>Servicios de hosting y almacenamiento</li>
              <li>Herramientas de análisis y marketing</li>
              <li>Servicios de atención al cliente</li>
            </ul>

            <h3 className="text-2xl font-semibold text-gray-900 mb-3 mt-6">4.3 Autoridades Legales</h3>
            <p className="text-gray-700 leading-relaxed">
              Podemos divulgar información cuando sea requerido por ley o para proteger nuestros derechos, seguridad 
              o propiedad.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">5. Seguridad de los Datos</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Implementamos medidas de seguridad técnicas y organizativas para proteger su información:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Encriptación de datos sensibles (SSL/TLS)</li>
              <li>Acceso restringido a información personal</li>
              <li>Monitoreo continuo de sistemas</li>
              <li>Auditorías de seguridad regulares</li>
              <li>Capacitación del personal en protección de datos</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">6. Sus Derechos</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              De acuerdo con la Ley 1581 de 2012 de Colombia, usted tiene derecho a:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Acceso:</strong> Conocer qué datos personales tenemos sobre usted</li>
              <li><strong>Rectificación:</strong> Corregir información inexacta o incompleta</li>
              <li><strong>Eliminación:</strong> Solicitar la eliminación de sus datos (sujeto a obligaciones legales)</li>
              <li><strong>Oposición:</strong> Oponerse al procesamiento de sus datos para ciertos fines</li>
              <li><strong>Portabilidad:</strong> Recibir sus datos en un formato estructurado</li>
              <li><strong>Revocación:</strong> Retirar su consentimiento en cualquier momento</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Para ejercer estos derechos, contáctenos a través de hola@mandadoexpress.co
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">7. Retención de Datos</h2>
            <p className="text-gray-700 leading-relaxed">
              Conservamos su información personal durante el tiempo necesario para cumplir con los fines descritos 
              en esta política, a menos que la ley requiera o permita un período de retención más largo. Los datos 
              de transacciones se conservan por al menos 5 años según las regulaciones fiscales colombianas.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">8. Cookies y Tecnologías Similares</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Utilizamos cookies y tecnologías similares para:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Mantener su sesión activa</li>
              <li>Recordar sus preferencias</li>
              <li>Analizar el tráfico del sitio web</li>
              <li>Personalizar contenido y anuncios</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              Puede configurar su navegador para rechazar cookies, aunque esto puede afectar la funcionalidad 
              de nuestros servicios.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">9. Privacidad de Menores</h2>
            <p className="text-gray-700 leading-relaxed">
              Nuestros servicios están dirigidos a personas mayores de 18 años. No recopilamos intencionalmente 
              información de menores de edad. Si descubrimos que hemos recopilado datos de un menor, los eliminaremos 
              de inmediato.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">10. Transferencias Internacionales</h2>
            <p className="text-gray-700 leading-relaxed">
              Sus datos pueden ser transferidos y procesados en servidores ubicados fuera de Colombia. Nos aseguramos 
              de que estas transferencias cumplan con las leyes de protección de datos aplicables y que sus datos 
              reciban un nivel adecuado de protección.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">11. Cambios a esta Política</h2>
            <p className="text-gray-700 leading-relaxed">
              Podemos actualizar esta Política de Privacidad periódicamente. Le notificaremos sobre cambios 
              significativos publicando la nueva política en nuestro sitio web y actualizando la fecha de 
              "Última actualización". Le recomendamos revisar esta política regularmente.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">12. Contacto</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Si tiene preguntas sobre esta Política de Privacidad o sobre cómo manejamos sus datos personales, 
              puede contactarnos:
            </p>
            <ul className="list-none text-gray-700 space-y-2">
              <li><strong>Responsable de Datos:</strong> Mandado Express</li>
              <li><strong>Email:</strong> mandadoexpresscol@gmail.com</li>
              <li><strong>Teléfono:</strong> +57 316 492 4439</li>
              <li><strong>Dirección:</strong> Carrera 40 Calle 14 Esquina, Manzana 9 Casa 6, Pereira, Risaralda, Colombia</li>
              <li><strong>WhatsApp:</strong> <a href="https://wa.me/message/2GTFXGJ74H5AD1" className="text-emerald-600 hover:text-emerald-700">Contactar por WhatsApp</a></li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">13. Autoridad de Control</h2>
            <p className="text-gray-700 leading-relaxed">
              Si considera que sus derechos de protección de datos han sido violados, puede presentar una queja 
              ante la Superintendencia de Industria y Comercio de Colombia (SIC), la autoridad de control en 
              materia de protección de datos personales.
            </p>
          </section>
        </div>

        <div className="mt-16 p-6 bg-emerald-50 rounded-2xl">
          <p className="text-gray-700 text-center">
            Su privacidad es importante para nosotros. Nos comprometemos a proteger sus datos personales y 
            a ser transparentes sobre cómo los utilizamos.
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white rounded-t-[32px] mx-10 mt-24">
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="text-center">
            <div className="text-gray-400 text-sm mb-4">
              © 2025 Mandado Express. Todos los derechos reservados.
            </div>
            <div className="flex justify-center space-x-6 text-sm">
              <Link to="/terms" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Términos de Servicio</Link>
              <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Privacidad</Link>
              <Link to="/" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Inicio</Link>
            </div>
            <div className="mt-6">
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-500 hover:text-emerald-400 transition-colors text-sm cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
